The position relative to the advertisement details where the video should be rendered.

Currently, two codes are defined:

- `Above` indicates the video will render above the advertisement details.
- `Below` indicates the video will render below the advertisement details.
